module.exports = __webpack_public_path__ + "static/resources-list-policy-and-setup-1-b61ff905c43507b5fe42811130641bb3.png";